// Module
var code = "<span class=\"time-display\" data-cy=\"recorder-time\">{{timerValue | formatTime: 'timer'}}</span>";
// Exports
module.exports = code;